/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const file_ppt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.29 4.5 8.62 1.353A1 1 0 0 0 7.857 1H2a1 1 0 0 0-1 1v11.843a1 1 0 0 0 1 1h2"
    />
    <path
      fill="#000"
      d="M5.81 8H4.138v4.667h1v-1.8h.674c1.006 0 1.593-.527 1.593-1.434C7.404 8.527 6.817 8 5.81 8Zm-.16 2.067h-.513V8.8h.514c.506 0 .74.2.74.633 0 .434-.234.634-.74.634ZM9.941 8H8.268v4.667h1v-1.8h.673c1.007 0 1.594-.527 1.594-1.434C11.535 8.527 10.948 8 9.94 8Zm-.16 2.067h-.513V8.8h.513c.507 0 .74.2.74.633 0 .434-.233.634-.74.634ZM15.765 8h-3.533v.8h1.267v3.867h1V8.8h1.266V8Z"
    />
  </svg>
)
export default file_ppt
